import React, {useState, useEffect} from "react";
import GeneralSettingsForm from "./generalSettingsForm";
import SubmitButton from "./submitButton";
import {useBillingContext} from "..";
import APIService from "../../../modules/apiService";

const api = new APIService();

export default function UpdateGeneralSettings() {
  const {showErrorModal, setBillingSettings, billingSettings} = useBillingContext();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  
  const [form, setForm] = useState({
    company_name: "",
    fantasy_name: "",
    fiscal_position: "6",
    iibb: "",
    business_address: "",
    activity_start_date: "",
  });
  
  useEffect(() => {
    if (billingSettings) {
      setForm({
        company_name: billingSettings.company_name || "",
        fantasy_name: billingSettings.fantasy_name || "",
        fiscal_position: billingSettings.fiscal_position || "6",
        iibb: billingSettings.iibb || "",
        business_address: billingSettings.business_address || "",
        activity_start_date: billingSettings.activity_start_date ? billingSettings.activity_start_date.split("T")[0] : "",
      });
    }
  }, [billingSettings]);
  
  const handleFormChange = (e) => {
    const newForm = {...form, [e.target.name]: e.target.value};
    setForm(newForm);
  };
  
  const handleSubmit = async (event) => {
    event.preventDefault();
    
    setIsSubmitting(true);
    setErrors({});
    
    try {
      const response = await api.putBillingSettings(form);
      const json = await response.json();
      
      if (response.ok) {
        setBillingSettings(json.data);
      } else if (response.status === 422) {
        setErrors(json?.errors ?? {});
      } else {
        throw new Error(json?.message);
      }
    } catch (err) {
      showErrorModal(err.message);
    }
    
    setIsSubmitting(false);
  };
  
  return (
    <form onSubmit={handleSubmit} autoComplete="off">
      <GeneralSettingsForm
        formData={form}
        errors={errors}
        handleChange={handleFormChange}
        disabled={isSubmitting}
      />
      <SubmitButton
        isSubmitting={isSubmitting}
        submittingText="Actualizando..."
        text="Guardar cambios"
      />
    </form>
  );
}
